import type { CryptoSelectOption } from "../../presentation/CryptoSelect";
import type { AssetAddressData } from "../types";
import { useAssetAddressForm } from "./AssetAddressForm.controller";
import { AssetAddressFormPresentation } from "./AssetAddressForm.pres";

export interface AssetAddressFormProps {
  onNext: (data: AssetAddressData) => void;
  initialValues?: Partial<AssetAddressData>;
  assetOptionsByChain: Record<string, CryptoSelectOption[]>;
  chainNameByCode: Record<string, string>;
  chainOptions: CryptoSelectOption[];
  onCancel: () => void;
}

export const AssetAddressForm = ({
  chainOptions,
  onCancel,
  ...controllerProps
}: AssetAddressFormProps) => {
  const controller = useAssetAddressForm(controllerProps);

  return (
    <AssetAddressFormPresentation
      {...controller}
      chainOptions={chainOptions}
      onCancel={onCancel}
    />
  );
};
